import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import * as serviceWorker from './serviceWorker';
window.location.href = "http://www.onpag.com.br/";
//ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();
